(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["plants-catalog"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var catalogs = document.querySelectorAll('[data-plants-catalog]');
    if (!catalogs.length) return;

    catalogs.forEach(function (catalog) {
      var filterBtns = catalog.querySelectorAll('.plants-catalog__filter-btn');
      var cards = catalog.querySelectorAll('.plant-card');
      var emptyEl = catalog.querySelector('.plants-catalog__empty');

      // ── Фільтрація ──────────────────────────────────────────────────────
      function applyFilter(filter) {
        var visibleCount = 0;
        cards.forEach(function (card) {
          var raw = card.getAttribute('data-tags') || '';
          var tags = raw.length ? raw.split(/\s+/) : [];
          var match = filter === 'all' || tags.indexOf(filter) !== -1;
          card.hidden = !match;
          if (match) visibleCount += 1;
        });
        if (emptyEl) emptyEl.hidden = visibleCount > 0;
      }

      filterBtns.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var filter = btn.getAttribute('data-filter');

          filterBtns.forEach(function (b) {
            b.classList.remove('is-active');
            b.setAttribute('aria-selected', 'false');
          });
          btn.classList.add('is-active');
          btn.setAttribute('aria-selected', 'true');

          applyFilter(filter);
        });
      });

      // ── Розгортання картки ──────────────────────────────────────────────
      catalog.querySelectorAll('.plant-card__toggle').forEach(function (toggle) {
        toggle.addEventListener('click', function () {
          var expanded = toggle.getAttribute('aria-expanded') === 'true';
          var card = toggle.closest('.plant-card');
          var extra = card ? card.querySelector('.plant-card__extra') : null;

          toggle.setAttribute('aria-expanded', expanded ? 'false' : 'true');
          if (extra) extra.hidden = expanded;
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
